import React, { useState } from 'react'
import { Card, Form, Table, Col } from 'antd'
import moment from 'moment-jalaali';
// import DatePicker from 'react-datepicker2';
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import ValidatorHelper from '../helpers/ValidatorHelper';
import XLSX from 'xlsx'
import strings from '../../utils/strings';
import { usePersistedStore } from '../../store/persisted-store';
import { useReportsStore } from '../../store/slices/createReportsSlice';

const columns = [
    {
        title: 'عنوان بیزنس',
        dataIndex: 'Business',
        key: "Business"
    }, {
        title: 'تعداد نشست',
        dataIndex: 'CntSession',
        key: "CntSession"
    },
    {
        title: 'تعداد بازدید',
        dataIndex: 'CntVizit',
        key: 'CntVizit',
    },
    {
        title: 'زمان گزارش',
        dataIndex: 'ReportDate',
        key: 'ReportDate',
        render: date => date && strings.getFarsiNum(moment(date).format('jYYYY/jMM/jDD HH:mm'))

    },]

const PageLogReport = () => {
    const reports = useReportsStore()
    const { auth } = usePersistedStore();
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const userInfoResources = auth.userInfo.Resources;
    const data = reports.pageLogReports.data
    const loading = reports.pageLogReports.loading

    function convertToMoment(date) {
        return moment(date?.toDate()).format("YYYY-MM-DD");
    }

    function onFinish(values) {

        // const fromDate = moment(values.fromDate).format('YYYY-MM-DD')
        // const toDate = moment(values.toDate).format('YYYY-MM-DD')

        reports.getPageLogReportsReports({
            fromDate: convertToMoment(fromDate),
            toDate: convertToMoment(toDate)
        });
    }

    function downloadxlsx() {
        if (data?.length === 0) return;
        let xlsxData = data?.map(d => {
            return [d.Business, d.CntSession, d.CntVizit, d?.ReportDate && strings.getFarsiNum(moment(d.ReportDate).format('jYYYY/jMM/jDD HH:mm'))]
        });
        xlsxData.unshift(["عنوان بیزنس", "تعداد نشست", "تعداد بازدید", "تاریخ بازدید"])
        const worksheet = XLSX.utils.aoa_to_sheet(xlsxData);
        const new_workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(new_workbook, worksheet, "SheetJS");
        XLSX.writeFile(new_workbook, "PageLogReports.xlsx")
    }

    return (
        <Card>
            <Col style={{
                display: "flex",
                gap: 20,
                marginBottom: 16,
                justifyContent: "space-between",
                alignItems: "center"
            }} xs={24}>
                <div style={{ fontSize: 16 }}>گزارش بازدید</div>
            </Col>
            <div style={{ fontSize: 14, marginBottom: 16 }}>بازه تاریخی مربوطه را انتخاب کنید</div>
            <Form
                onFinish={onFinish}
                layout="inline"
            >
                <Form.Item
                    rules={ValidatorHelper.required("تاریخ")}
                    style={{ width: "220px" }}
                    name='fromDate'
                    label='از تاریخ'>
                    <DatePicker
                        value={fromDate}
                        onChange={setFromDate}
                        calendar={persian}
                        locale={persian_fa}
                        format="YYYY/MM/DD"
                        inputClass="datepicker-input"
                        calendarPosition="bottom-right"
                        portal
                        zIndex={1070}
                    />
                </Form.Item>
                <Form.Item
                    rules={ValidatorHelper.required("تاریخ")}
                    style={{ width: "220px" }}
                    name='toDate'
                    label='تا تاریخ'>
                    <DatePicker
                        value={toDate}
                        onChange={setToDate}
                        calendar={persian}
                        locale={persian_fa}
                        format="YYYY/MM/DD"
                        inputClass="datepicker-input"
                        calendarPosition="bottom-right"
                        portal
                        zIndex={1070}
                    />
                </Form.Item>
                <button
                    style={{
                        float: "left",
                        padding: "0 17px",
                        height: 33,
                    }}
                    disabled={loading} type="primary" className="btn btn-primary waves-effect waves-light" htmltype="submit">
                    جستجو&nbsp;&nbsp;&nbsp; <i className={loading ? "bx bx-loader bx-spin" : "fas fa-search"}></i>
                </button>

                {data?.length > 0 && userInfoResources && userInfoResources?.includes("BusinessAdmin") && <Col style={{ marginRight: "auto", marginLeft: 18 }} xs={3}>
                    <div style={{ whiteSpace: "nowrap" }}>
                        {<div style={{ cursor: "pointer" }} onClick={downloadxlsx} className="btn-success border-0 rounded ml-auto pb-2 pt-2 pr-3 pl-3 mr-2 mb-2"> <i className="far fa-file-excel font-size-14 align-middle mr-2"></i>دریافت اکسل</div>}
                    </div>
                </Col>}

            </Form>
            <div>
                <Table
                    style={{ overflowX: 'scroll' }}
                    size="small"
                    className="custom-table"
                    loading={loading}
                    bordered
                    rowKey="ReportDate"
                    columns={columns}
                    dataSource={data}
                />
            </div>
        </Card>
    )
}

export default PageLogReport
